import * as R from 'ramda';
import React, { useMemo } from 'react';
// components
import { Table } from '../../../../components/table';
// features
import PC from '../../../permission/role-permission';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// hooks
import useEditViewHook from '../../../../hooks/use-edit-view';
// feature payroll
import {
  getDefaultReportFields,
  payrollInvoicesTableSettings,
  vendorPayrollInvoicesColumnSettings,
} from '../../settings/charges-table-settings';
//////////////////////////////////////////////////

const TripTab = (props: Object) => {
  const { maxHeight, handleOpenTrip, payrollInvoices, handleEditDriverInvoice, handleRemoveInvoiceFromPayroll } = props;

  const getPermissions = ({ completed }: Object) => G.ifElse(
    G.isTrue(completed),
    [PC.TEL_INVOICE_OVERWRITE_EXECUTE],
    [PC.TEL_FLEET_INVOICE_WRITE, PC.TEL_INVOICE_OVERWRITE_EXECUTE],
  );

  const actionButtons = [
    {
      getPermissions,
      iconName: 'pencil',
      action: handleEditDriverInvoice,
    },
    {
      getPermissions,
      iconName: 'trash',
      action: handleRemoveInvoiceFromPayroll,
    },
  ];

  const report = G.getReportFromColumnSettings(vendorPayrollInvoicesColumnSettings, {
    [GC.FIELD_TYPE]: GC.VENDOR_PAYROLL_UI_REPORTS,
    [GC.FIELD_GUID]: `${GC.VENDOR_PAYROLL_UI_REPORTS}PayrollInvoicesReport`,
  });

  const tableSettings = R.assoc('maxHeight', maxHeight, payrollInvoicesTableSettings);

  const { uiReportFields, handleOpenEditView } = useEditViewHook({
    ...props,
    report,
    columnSettings: vendorPayrollInvoicesColumnSettings,
    defaultReportFields: getDefaultReportFields(report),
  });

  const sortedReport = useMemo(() => (
    G.isNilOrEmpty(uiReportFields) ?
    report : G.getSortedReport(uiReportFields, report)
  ), [uiReportFields]);

  return (
    <Table
      showEditView={true}
      report={sortedReport}
      shouldUseUIFilters={true}
      itemList={payrollInvoices}
      useSearchableColumns={true}
      withResizableColumns={true}
      actionButtons={actionButtons}
      tableSettings={tableSettings}
      useNewTitleFilterInputs={true}
      callbackData={{ handleOpenTrip }}
      handleClickEditOrder={handleOpenEditView}
      columnSettings={vendorPayrollInvoicesColumnSettings}
      filterProps={G.getFilterPropsFromColumnSettings(vendorPayrollInvoicesColumnSettings)}
    />
  );
};

export default TripTab;
